module.exports = __webpack_public_path__ + "assets/img/clientactions.b7b9a4dc.svg";